import '../CampaignEditor/campaign_editor.scss';

import { bool, func, string } from 'prop-types';
import React from 'react';
import { Badge, Button } from 'reactstrap';

import BalanceModal from '../../balance/BalanceModal/BalanceModalWithOpportunity';
import { PROJECT_VIEW } from '../../constants';
import CreativesModal from '../../creative-assets/CreativesModal.container';
import { getTooltipButtonWithText, InfoTooltip } from '../../generic/Tooltip';
import { campaignShape } from '../../prop-types';
import api from '../../REST/api';
import DeleteButton from '../../REST/DeleteButton';
import { submit } from '../actions';
import CampaignStatus from '../CampaignStatus';
import CreateChangeRequest from '../CreateChangeRequest/CreateChangeRequest';
import HELP_TEXTS from '../utils/help-texts';

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);
export default function CampaignHeader({
  campaign,
  isChangeRequestAllowed,
  onCreativeModalClose,
  view,
  guardModified,
  hasCountdownProducts,
  campaignSave,
}) {
  const { opportunity, status, needsManualInvoicing } = campaign;

  let title = `${campaign.nCode} - ${opportunity.campaignObjective}`;
  if (opportunity.useCase) title = `${title} - ${opportunity.useCase}`;

  return view === PROJECT_VIEW ? (
    <div className="d-flex mb-2">
      <div className="ml-auto">
        <CreateChangeRequest
          disabled={!isChangeRequestAllowed}
          campaign={campaign}
        />
      </div>
    </div>
  ) : (
    <>
      {needsManualInvoicing && (
        <Badge color="info" pill className="badge-text mb-3">
          {HELP_TEXTS.manualInvoicing}

          <InfoTooltip target="budget-split-tooltip">
            {HELP_TEXTS.manualInvoicingToolTip}
          </InfoTooltip>
        </Badge>
      )}
      <div className="d-flex pb-3 align-items-center">
        <h3 className="m-0">{title}</h3>
        <div className="ml-3">
          <CampaignStatus status={status} />
        </div>
        {guardModified && !hasCountdownProducts && (
          <h5>
            <Badge className="ml-3 mt-2" color="warning">
              Unsaved changes
            </Badge>
          </h5>
        )}
        <ul className="list-inline ml-auto mb-0">
          <li className="list-inline-item">
            <CreativesModal
              opportunityName={opportunity.name}
              campaignSave={campaignSave}
              opportunityId={opportunity.id}
              onClose={onCreativeModalClose}
              campaignRelatedProducts
            />
          </li>
          <li className="list-inline-item">
            <BalanceModal id={opportunity.id} />
          </li>
          <li className="list-inline-item">
            <CreateChangeRequest
              disabled={!isChangeRequestAllowed}
              campaign={campaign}
              tag={ButtonWithTooltip}
              additionalButtonProps={{
                helpKey: 'requestChange',
                section: 'header',
                showTooltip: !isChangeRequestAllowed,
              }}
            />
          </li>
          <li className="list-inline-item ml-5">
            <DeleteButton
              className="mr-2"
              onDelete={api.destroyCampaign}
              id={campaign.id}
              name={`the campaign - ${title}`}
              redirectTo="/campaigns"
            />
            <Button
              type="submit"
              onClick={() => {
                const linesInRed =
                  document.getElementsByClassName('border-red');
                [...linesInRed].forEach(line =>
                  line.classList.remove('border-red'),
                );
                return submit();
              }}
              color="primary"
            >
              Save
            </Button>
          </li>
        </ul>
      </div>
    </>
  );
}

CampaignHeader.propTypes = {
  campaign: campaignShape.isRequired,
  onCreativeModalClose: func.isRequired,
  isChangeRequestAllowed: bool.isRequired,
  view: string,
  guardModified: bool.isRequired,
  hasCountdownProducts: bool.isRequired,
  campaignSave: func.isRequired,
};

CampaignHeader.defaultProps = {
  view: '',
};
